import React, { Component } from 'react'
import { Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

import Router from '../../costra/Router.js'
import Dialogs from '../../costra/Dialogs.js'
import Translate from '../../costra/Translate.js'
import SimpleListContainer from '../../costra/SimpleListContainer.js'
import Table from '../../utils/Table.js'

import ErrorPlaceholder from '../../utils/ErrorPlaceholder.js'
import LoadingPlaceholder from '../../utils/LoadingPlaceholder.js'
import SearchContainer from '../../utils/SearchContainer.js'

import RemoveUserDialog from './RemoveUserDialog.js'

import '../../css/list.css'
import TableHeader from '../../utils/TableHeader.js'

const columns = [
  {
    title: () => Translate.get('table.login'),
    dataIndex: 'login',
    key: 'login',
    width: '50%',
    render: (text, record) => <Button type="link" style={{ fontWeight: 'bold', padding: 0 }} onClick={() => Router.go('/users/' + record.key)}>{text}</Button>
  },
  {
    title: () => Translate.get('table.name'),
    dataIndex: 'name',
    key: 'name',
    width: '50%',
  },
  {
    title: '',
    key: 'action',
    fixed: 'right',
    width: 100,
    align: 'right',
    render: (_, record) => (
      <Button icon={<DeleteOutlined />} title={Translate.get('delete.button')} onClick={() => Dialogs.open(<RemoveUserDialog item={record} />)}/>
    ),
  }
]

class Users extends Component {

  constructor(props) {
    super(props)
    var state = SimpleListContainer.initialState()
    state.itemsPerPage = 50
    state.searchedText = ''
    this.state = state
    this.container = new SearchContainer(this, 'com.optimsys.costra.optimcall.shiftplanner.user.Users', () => {
      this.setState({ error: 'error.load.users' })
    })

  }

  componentDidMount() {
    this.container.reload()
  }

  componentWillUnmount() {
    this.container.close()
  }

  render() {
    if (this.state.error) {
      return <ErrorPlaceholder error={this.state.error} />
    }
    if (!this.state.items) {
      return <LoadingPlaceholder />
    }

    const data = this.state.items.map(item => {
      return {
        key: item._id.$oid,
        login: item.login || Translate.get('entity.unnamed'),
        name: item.extensions?.adv?.displayName,
      }
    })

    return <div className="content-column">
      <TableHeader
        icon="user"
        title="user.section"
        noTenant={this.state.noTenant}
        allowAdd={this.state.allowAdd}
        addPath="/users/new"
        addTitle="user.create.button"
      />

      <Table
        component={this}
        container={this.container}
        columns={columns}
        data={data}
      />
    </div>
  }
}

export default Users